module.exports = __webpack_public_path__ + "static/media/Vec vectores_TC rojo.260c5321.svg";